import { Observable } from 'rxjs'

import { MUTATE_PICKLIST, setPicklists } from '~/redux/picklistsReducer'

export default function picklistsEpic(
  action$,
  _store,
  { serviceResolver } // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> {
  return action$.ofType(MUTATE_PICKLIST).map((action) => {
    const picklistData = serviceResolver('picklistService').get()
    picklistData.picklists[action.payload.picklistKey].picklist.push(
      action.payload.item
    )
    return setPicklists(picklistData)
  })
}
